import * as React from "react";
import Draggable from "./Draggable";

export interface DraggableItem {
  id: string | number;
}

export interface DraggableItems {
  /* tslint:disable:array-type */
  items: Array<DraggableItem | any>;
  setItems: (items: any) => void;
  children?: React.ReactNode;
  component: (item: any) => JSX.Element;
  length: number;
}

const SortableMenuList = ({
  items,
  setItems,
  component,
  length,
}: DraggableItems) => {
  const [dragId, setDragId] = React.useState("");

  const arrayMove = (arr: Array<any>, oldIndex: number, newIndex: number) => {
    if (newIndex >= arr.length) {
      let k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }

    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);

    return arr;
  };

  const onDrop = (ev: any, item: any) => {
    // let currentPos = 0;
    // let droppedPos = 0;

    // for (let i = 0; i < items.length; i++) {
    //   if (dragId === items[i]._id) {
    //     currentPos = i;
    //   }
    //   if (ev.currentTarget.id === items[i]._id) {
    //     droppedPos = i;
    //   }
    // }
    const currentPos = parseInt(dragId,10);
    const droppedPos = item;

    const newItems = arrayMove([...items], currentPos, droppedPos);
    setItems(newItems);
  };

  const onDragStart = (ev: any, item: any) => {
    // setDragId(item._id);
    setDragId(item);
  };

  const renderComponent = (componentJsx: any, item: any, index: number) => {
    const Component = componentJsx;

    return <Component item={item} index={index} />;
  };

  return (
    <>
      {Object.keys(items).map((item: any, index) => (
        <Draggable
          key={index}
          id={item}
          onDrop={onDrop}
          onDragStart={onDragStart}
          item={item}
          length={length}
        >
          {renderComponent(component, items[item], index)}
        </Draggable>
      ))}
    </>
  );
};

export default SortableMenuList;
